/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Industries
 */
export interface Industries {
}

/**
 * Check if a given object implements the Industries interface.
 */
export function instanceOfIndustries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IndustriesFromJSON(json: any): Industries {
    return IndustriesFromJSONTyped(json, false);
}

export function IndustriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Industries {
    return json;
}

export function IndustriesToJSON(value?: Industries | null): any {
    return value;
}

